{
  "name": "aisearch-adminconsole-fe",
  "version": "1.1.17",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build:develop": "ng build aisearch-search-fe-library && ng build --configuration development",
    "build:release": "ng build aisearch-search-fe-library && ng build --configuration release",
    "build:prod": "ng build aisearch-search-fe-library && ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "echo true",
    "test-to-be": "ng test --no-watch --no-progress --code-coverage --browsers=ChromeHeadlessCI",
    "test:specific": "ng test --watch --include='src/app/auth/**/*.spec.ts'",
    "coverage": "ng test --watch=false --code-coverage",
    "deploy": "gcloud builds submit --config cloudbuild.yaml"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.16",
    "@angular/common": "^21.2.16",
    "@angular/compiler": "^21.2.16",
    "@angular/core": "^21.2.16",
    "@angular/fire": "^21.0.0-rc.0",
    "@angular/forms": "^21.2.16",
    "@angular/platform-browser": "^21.2.16",
    "@angular/platform-browser-dynamic": "^21.2.16",
    "@angular/router": "^21.2.16",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/free-brands-svg-icons": "^6.7.1",
    "@fortawesome/free-regular-svg-icons": "^6.7.1",
    "@fortawesome/free-solid-svg-icons": "^6.7.1",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@popperjs/core": "^2.11.8",
    "bootstrap": "^5.3.3",
    "chart.js": "^4.4.9",
    "chartjs-plugin-datalabels": "^2.2.0",
    "firebase": "^11.2.0",
    "jwt-decode": "^4.0.0",
    "ngx-file-drop": "^16.0.0",
    "ngx-markdown": "^21.3.0",
    "ngx-permissions": "^19.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.14",
    "@angular/cli": "^21.2.14",
    "@angular/compiler-cli": "^21.2.16",
    "@angular/localize": "^21.2.16",
    "@types/chart.js": "^4.0.1",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^21.2.5",
    "typescript": "~5.9.3"
  },
  "overrides": {
    "@grpc/grpc-js": "^1.14.0"
  }
}
